import React from 'react';
import {Wrapper} from "./historyPageStyles";
import HistoryTable from 'components/HistoryTable/HistoryTable'

const HistoryPage = () => {
    return (
        <Wrapper>
            <HistoryTable/>
        </Wrapper>
    );
};

export default HistoryPage;
